import {
  Space, Typography, Form, Input, Button, Flex, App
} from "antd";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { UPDATE_PROFESSIONIST_PASSWORD } from "../settings.gql";
import { PASSWORD_MIN_LENGTH } from "../../../constants/app";

const { Text } = Typography;

const Security = () => {
  const { t } = useTranslation();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { message } = App.useApp();
  const [form] = Form.useForm();

  const [update, { loading }] = useMutation(UPDATE_PROFESSIONIST_PASSWORD, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      form.resetFields();
      message.success(t("user.success.updatePassword"));
    },
    onError: ({ graphQLErrors }) => {
      message.error(graphQLErrors[0].message);
    }
  });

  return (
    <Space size={0} direction="vertical" style={{ width: "100%" }}>
      <Space direction="vertical" style={{ marginBottom: 24 }}>
        <Text strong style={{ fontSize: 22, lineHeight: 1 }}>{t("settingsPage.security.title")}</Text>
        <Text type="secondary" style={{ fontSize: 18, lineHeight: 1 }}>
          {t("settingsPage.security.subtitle")}
        </Text>
      </Space>
      <Form
        form={form}
        layout="vertical"
        style={{ maxWidth: 460 }}
        onFinish={(values) => {
          const {
            currentPassword,
            newPassword,
            repeatPassword
          } = values;

          update({
            variables: {
              currentPassword,
              newPassword,
              repeatPassword
            }
          });
        }}
      >
        <Form.Item
          name="currentPassword"
          label={t("form.label.passwordCurrent")}
          rules={[
            { required: true, message: t("form.error.passwordActual") },
            {
              min: PASSWORD_MIN_LENGTH,
              message: t("form.error.passwordMin", { length: PASSWORD_MIN_LENGTH }),
            }
          ]}
        >
          <Input.Password
            placeholder={t("form.label.password")}
            visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={t("form.label.passwordNew")}
          rules={[
            { required: true, message: t("form.error.passwordNew") },
            {
              min: PASSWORD_MIN_LENGTH,
              message: t("form.error.passwordMin", { length: PASSWORD_MIN_LENGTH }),
            }
          ]}
        >
          <Input.Password
            placeholder={t("form.error.password")}
            visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
          />
        </Form.Item>
        <Form.Item
          name="repeatPassword"
          label={t("form.label.passwordRepeat")}
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t("form.error.passwordMatch")));
              },
            }),]}
          dependencies={["newPassword"]}
        >
          <Input.Password
            placeholder={t("form.label.password")}
            visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
          />
        </Form.Item>
        <Form.Item>
          <Flex justify="flex-end">
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              loading={loading}
            >
              {t("settingsPage.security.submitButton")}
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Space>
  );
};

export default Security;
